export default __webpack_public_path__ + "static/media/Email_Illustration_left.a5c6e35b.png";